angular.module('dnecom')
    .controller('StoresController', ["$scope", "wizardModal", "Utils", "$http", "$timeout", "notifications", "$location", "StoreUtils", "StoreLicense", "DTOptionsBuilder", function($scope, wizardModal, Utils, $http, $timeout, notifications, $location, StoreUtils, StoreLicense, DTOptionsBuilder) {
        $scope.currentStore = {};
        $scope.loading = false;
        $scope.error = false;
        $scope.tableInstance = {};
        $scope.license = StoreLicense;
        $scope.location = TemplateData.value('location');
        $scope.transactions = TemplateData.value('transactions');
        $scope.store = $scope.location == 'storeDashboard' ? TemplateData.value('store') : {};
        $scope.stores = [];
        $scope.archivedStores = [];
        $scope.showArchivedStores = false;
        $scope.userRole = TemplateData.value('userRole');

        $scope.$watch('stores', function(newValue, oldValue) {
            if (_.size(newValue) !== _.size(oldValue) && $scope.userRole != 'ROLE_LOCAL_MANAGER') {
                $scope.license.loadInfo();
            }
        }, true);

        $scope.dtInstanceCallback = function(dtInstance) {
            $scope.tableInstance = dtInstance;
        };

        $scope.dtStoresOptions = DTOptionsBuilder.newOptions().withOption('aaSorting', [[0, 'asc']]);

        $scope.dtStoresColumnDefs = [{
            targets: [3,4],
            orderable: false
        }, {
            targets: [0, 1, 2, 3, 4],
            width: '20%'
        }, {
            targets: 'col-hidden',
            visible: false
        }];

        $scope.init = function() {
            $scope.getStores();
            $scope.getArchivedStores();

            var action = $location.search().action;
            if (action && action == 'new') {
                $scope.addStore();
            }
        };

        $scope.showHideArchivedStores = function() {
            if ($scope.showArchivedStores) {
                var temp = angular.copy($scope.stores);
                $scope.stores = [];
                _.each(temp, function(store) {
                    if (store.deletedAt === null) {
                        $scope.stores.push(store);
                    }
                });
                $scope.showArchivedStores = false;
            } else {
                _.each($scope.archivedStores, function(store) {
                   $scope.stores.unshift(store);
                });
                $scope.showArchivedStores = true;
            }
        };

        $scope.addStore = function() {
            $scope.editStore();
        };

        $scope.getStores = function() {
            $scope.loading = true;
            $http.get(Routing.generate('stores_get')).success(function(data) {
                if (data.hasOwnProperty('stores')) {
                    $scope.stores = data.stores;
                } else {
                    notifications.danger('Request error.');
                }
            }).finally(function() {
                $timeout(function() {
                    $scope.loading = false;
                });
            });
        };

        $scope.getArchivedStores = function() {
            $scope.loading = true;
            $http.get(Routing.generate('stores_get_deleted')).success(function(data) {
                if (data.hasOwnProperty('stores')) {
                    $scope.archivedStores = data.stores;
                } else {
                    notifications.danger('Request error.');
                }
            }).finally(function() {
                $timeout(function() {
                    $scope.loading = false;
                });
            });
        };

        $scope.editStore = function(store, index) {
            if (!store) {
                $scope.currentStore = {};

                var params = $location.search();
                var integrations = {};

                if (params.a) {
                   integrations.autoresponder = params.a;
                }

                $scope.currentStore = { properties: { integrations: integrations } };

                if (params.p) {
                    $scope.currentStore.paymentMethods = [
                        {
                            accountId: params.p
                        }
                    ]
                }

                $scope.prepareWizardModal(index);
                return;
            }

            $scope.currentStore = angular.copy(store);

            $http.get(Routing.generate('stores_properties', {
                id: store.id
            }))
                .success(function(data) {
                    if (!data.hasOwnProperty('properties')) {
                        notifications.danger(response.data.message);
                        return;
                    }

                    if (!data.properties || data.properties === []) {
                        data.properties = {};
                    }
                    $scope.currentStore.properties = data.properties;
                    $scope.prepareWizardModal(index);
                })
            ;
        };

        $scope.prepareWizardModal = function(index) {
            var storeModal = wizardModal.open({
                templateUrl: 'storeWizardModal.html',
                controller: 'StoreModalController',
                size: '',
                resolve: {
                    store: function() {
                        return $scope.currentStore;
                    }
                }
            });

            storeModal.result.then(function(editedStore) {
                $scope.saveStore(editedStore);
            }, function() {
                if (index && !angular.equals($scope.currentStore, $scope.stores[index])) {
                    $scope.stores[index] = $scope.currentStore;
                }
            });
        };

        $scope.archiveStore = function(store) {
            $http.delete(Routing.generate('stores_delete', {
                id: store.id
            })).then(function(response) {
                if (!response.data.success) {
                    notifications.danger(response.data.message);
                    return;
                }

                notifications.success('Store has been archived.');

                window.location.href = Routing.generate('stores');
            }, function(response) {
                notifications.danger('Request error.');
            });
        };

        $scope.restoreStore = function(store) {
            $http.get(Routing.generate('stores_restore', {
                id: store.id
            })).then(function(response) {
                if (!response.data.success) {
                    notifications.danger(response.data.message);
                    return;
                }

                notifications.success('Store has been restored.');
                $scope.updateStore(response.data.store);
            }, function() {
                notifications.danger('Request error.');
            });
        };

        $scope.saveStore = function(store) {
            var id = 0;
            if (store.hasOwnProperty('id')) {
                id = store.id;
            }

            $http.put(Routing.generate('stores_update', {
                id: id
            }), store).then(function(response) {
                if (response.data.success) {
                    notifications.success('Store saved.');
                    if (id != 0) {
                        $scope.updateStore(response.data.store);
                    } else {
                        $scope.stores.push(response.data.store);
                    }
                } else {
                    notifications.danger(response.data.message);
                }
            }, function(response) {
                notifications.danger('Request error.');
            });
        };

        $scope.updateStore = function(store) {
            for (var i in $scope.stores) {
                if ($scope.stores[i].id == store.id) {
                    $scope.stores[i] = store;
                    return;
                }
            }
        };

        $scope.searchTable = function(search) {
            $scope.tableInstance.DataTable.search(search);
            $scope.tableInstance.DataTable.draw();
        };

        $scope.setupMobileStore = function (store) {
            if (store.mobileEnabled) {
                redirectToMobileSettings(store);
                return;
            }

            var mobileStoreSetupModal = wizardModal.open({
                templateUrl: 'mobileStoreModal.html',
                controller: 'StoreSetupMobileModalController',
                resolve: {
                    store: function () {
                        return store;
                    }
                }
            });

            mobileStoreSetupModal.result.then(function (editedStore) {
                StoreUtils.activateMobileStore(editedStore, function (response) {
                    editedStore.mobileEnabled = response.store.mobileEnabled;
                    notifications.success('Mobile store activated!');
                    redirectToMobileSettings(editedStore);
                }, function (data) {
                    notifications.danger(data.message ? data.message : 'Error occurred while activating mobile store!')
                });
            });
        };

        var redirectToMobileSettings = function (store) {
            window.location = Routing.generate('stores_mobile_settings', { id: store.id });
        }
    }]);
